import actionTypes from './actionTypes';

const requestPlayers = () => ({
    type: actionTypes.REQUEST_PLAYERS,
});

const requestGoalies = () => ({
    type: actionTypes.REQUEST_GOALIES,
});

const playersResponse = (success, players, gameType, errors) => ({
    type: actionTypes.PLAYERS_RESPONSE,
    payload: {
        success,
        players,
        gameType,
        errors
    }
});

const goaliesResponse = (success, players, gameType, errors) => ({
    type: actionTypes.GOALIES_RESPONSE,
    payload: {
        success,
        players,
        gameType,
        errors
    }
});

const getPointsLeaders = (pointsLeaders, gameType) => ({
    type: actionTypes.POINTS_LEADERS,
    payload: {
        pointsLeaders,
        gameType
    }
});

const getGoalsLeaders = (goalsLeaders, gameType) => ({
    type: actionTypes.GOALS_LEADERS,
    payload: {
        goalsLeaders,
        gameType
    }
});

const getWinsLeaders = (winsLeaders, gameType) => ({
    type: actionTypes.WINS_LEADERS,
    payload: {
        winsLeaders,
        gameType
    }
});

const getGAALeaders = (gaaLeaders, gameType) => ({
    type: actionTypes.GAA_LEADERS,
    payload: {
        gaaLeaders,
        gameType
    }
});

const setSelectedGameType = (gameType) => ({
    type: actionTypes.SET_SELECTED_GAME_TYPE,
    payload: {
        selectedGameType: gameType
    }
});

export default {
    requestPlayers,
    requestGoalies,
    playersResponse,
    goaliesResponse,
    getPointsLeaders,
    getGoalsLeaders,
    getWinsLeaders,
    getGAALeaders,
    setSelectedGameType
};